// Las Vegas Braces (Brand 4 - Dr. John Griffiths). Three offices: East, West, North.
// Backend: bondLocations.ts LAS_VEGAS_EAST/WEST/NORTH (brandId "las_vegas_braces").
//   EAST  -> catalog 4a4dcf42, Edge loc 2, procedure 392 (DB 410, shared w/ West)
//   WEST  -> catalog 4a4dcf42, Edge loc 5, procedure 392 (DB 410, shared w/ East)
//   NORTH -> catalog 5748898d, Edge loc 3, procedure 392 (DB 409, separate)
// English-only (one Spanish review only on the live site).
//
// THEME COLORS: scoured 2026-06-29 from lasvegasbraces.com. Primary = orange CTA
// (#f57e39, white text). Site chrome is pure black; primaryDark set to a usable
// dark slate (#1c2530) for widget UI rather than #000.
import type { BrandConfig } from "./types";

export const lasVegas: BrandConfig = {
  slug: "las-vegas",
  brandId: "las_vegas_braces",
  brandName: "Las Vegas Braces",
  logo: "https://lasvegasbraces.com/wp-content/uploads/2023/10/Griffiths-logo-01.png",
  phone: "(702) 835-7979",
  phoneHref: "tel:+17028357979",
  theme: { primary: "#f57e39", primaryDark: "#1c2530" }, // scoured 2026-06-29: site CTA orange + dark slate
  locales: ["en", "es"],
  locations: {
    LAS_VEGAS_EAST: {
      id: "LAS_VEGAS_EAST",
      name: "East",
      addressLines: ["4240 E. Charleston Blvd.", "Las Vegas, NV 89104"],
      mapsUrl: "https://maps.google.com/?q=4240+E+Charleston+Blvd+Las+Vegas+NV+89104",
      timezone: "America/Los_Angeles",
      // Per-office line as published on lasvegasbraces.com (2026-08-04). The brand
      // phone below is a real central number, but East/West each answer their own.
      phone: "(702) 452-2267",
      phoneHref: "tel:+17024522267",
      // Native booking restored (2026-07) via the backend CapSolver token mint.
      // Revert to the Ortho2 SPA handoff by uncommenting (East+West catalog 4a4dcf42):
      // ortho2BookingUrl: "https://edgebooking.ortho2.com/search?catalog=4a4dcf42-2f98-44de-ae47-7a6538bc7b10&code=jeftkq",
    },
    LAS_VEGAS_WEST: {
      id: "LAS_VEGAS_WEST",
      name: "West",
      addressLines: ["8710 W. Charleston Blvd., Suite 150", "Las Vegas, NV 89117"],
      mapsUrl: "https://maps.google.com/?q=8710+W+Charleston+Blvd+Suite+150+Las+Vegas+NV+89117",
      timezone: "America/Los_Angeles",
      phone: "(702) 256-7846",
      phoneHref: "tel:+17022567846",
      // Native booking restored (2026-07) via the backend CapSolver token mint.
      // Revert to the Ortho2 SPA handoff by uncommenting (East+West catalog 4a4dcf42):
      // ortho2BookingUrl: "https://edgebooking.ortho2.com/search?catalog=4a4dcf42-2f98-44de-ae47-7a6538bc7b10&code=jeftkq",
    },
    // North (6365 Simmons St, catalog 5748898d) removed 2026-07-14 — Bond is
    // closing that location (Tarra), so it is no longer a scheduling option.
    // The backend LAS_VEGAS_NORTH entry stays for historical/voice handling.
  },
  locationAliases: {
    EAST: "LAS_VEGAS_EAST",
    CHARLESTON_EAST: "LAS_VEGAS_EAST",
    WEST: "LAS_VEGAS_WEST",
    CHARLESTON_WEST: "LAS_VEGAS_WEST",
    LAS_VEGAS: "LAS_VEGAS_EAST",
  },
};
